import { FC, ReactNode } from 'react'
import { AnalyticsDate, AnalyticsDateType } from './Date'
import {
  AnalyticsMembershipProgram,
  AnalyticsMembershipProgramType,
} from './MembershipProgram'
import { AnalyticsProduct, AnalyticsProductType } from './Product'
import { RowStatistics, RowStatisticsType } from './RowStatistics'
import { AnalyticsStatistic, AnalyticsStatisticType } from './Statistic'
import { AnalyticsUnavailable, AnalyticsUnavailableType } from './Unavailable'
import { venueRangePresets } from './rangePresets'

const Analytics: FC &
  AnalyticsDateType &
  AnalyticsStatisticType &
  AnalyticsProductType &
  AnalyticsMembershipProgramType &
  AnalyticsUnavailableType &
  RowStatisticsType & {
    rangesPresets: { venue: typeof venueRangePresets }
  } = (): ReactNode => <></>

Analytics.Date = AnalyticsDate
Analytics.Statistic = AnalyticsStatistic
Analytics.RowStatistics = RowStatistics
Analytics.Product = AnalyticsProduct
Analytics.MembershipProgram = AnalyticsMembershipProgram
Analytics.Unavailable = AnalyticsUnavailable
Analytics.rangesPresets = {
  venue: venueRangePresets,
}

export default Analytics
